import { render, staticRenderFns } from "./EditPlaylistSoundsModal.vue?vue&type=template&id=05c9fc6a&"
import script from "./EditPlaylistSoundsModal.vue?vue&type=script&lang=js&"
export * from "./EditPlaylistSoundsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPlaylistSoundsModal.vue?vue&type=style&index=0&id=05c9fc6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports